import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { DxToastComponent } from 'devextreme-angular';
import { ErrorsService } from '../errors/errors.service';
import { ActionsService } from '../actions/actions.service';
import { AppService } from '@app/app.service';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';

@Component({
    selector: 'facnm-notifications',
    templateUrl: './notifications.component.html',
    styleUrls: ['./notifications.component.scss']
})
export class NotificationsComponent implements OnInit {

    private unsubscribe$ = new Subject<void>();

    @ViewChild('toast', { static: true }) toast: DxToastComponent;

    @Input() entityName;

    toastContentType: string;
    toastTitle: string;
    toastMessage: string;

    toastQueued: boolean;


    constructor(private app$: AppService, private errors$: ErrorsService, private actions$: ActionsService) {

        app$.ScreenReady.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {

            if (this.toastQueued) {
                this.toast.instance.show();
                this.toastQueued = false;
            }

        });


        actions$.EntityCreated.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            this.toast.instance.hide();

            this.toastContentType = 'create'
            this.toast.type = 'success';

            this.toastQueued = true;
        });

        actions$.EntitySaved.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            this.toast.instance.hide();

            this.toastContentType = 'save';
            this.toast.type = 'success';

            this.toastQueued = true;
        });

        actions$.EntityDeleted.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            this.toast.instance.hide();

            this.toastContentType = 'delete';
            this.toast.type = 'success';

            this.toastQueued = true;
        });

        actions$.EntityResetting.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
            this.toast.instance.hide();

            this.toastContentType = 'reset';
            this.toast.type = 'success';

            this.toast.instance.show();
        });


        actions$.EntityBusy.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {

            this.toast.instance.hide();
        });


        actions$.EntityCustomAction.pipe(takeUntil(this.unsubscribe$)).subscribe((value) => {

            this.toast.instance.hide();

            this.toastContentType = 'custom';
            this.toast.type = value.type ? value.type :'success';
            this.toastTitle = value.title;
            this.toastMessage = value.message;

            this.toast.instance.show();
        });
    }


    ngOnInit() {

        this.errors$.ServerErrorsReceived.pipe(takeUntil(this.unsubscribe$)).subscribe((errors) => {

            if (errors) {

                this.toast.instance.hide();

                if (errors.modelState) {
                    this.toastMessage = 'The ' + this.entityName + ' contains errors';
                }
                else {
                    this.toastMessage = errors.message;
                }

                this.toastContentType = 'error';
                this.toast.type = 'error';

                this.toast.instance.show();
            }
        });
    }


    ngOnDestroy(): void {
        this.unsubscribe$.next();
        this.unsubscribe$.complete();
    }

}
